import React from 'react';
import classnames from 'classnames';
import { WrapperItem } from '../components/wrapper-item';
import { Section } from '../components/section';
import { Column } from '../components/column';
import { Image } from '../components/image';
import { Text } from '../components/text';
import { LinkWrapper } from '../components/link-wrapper';
import { shorthand } from '../utils/css-utils';
import { mobileFullWidthColumnClassName } from '../utils/defaults';
export const SectionLink = (props) => {
    const { section, cssClass, isRtl, columnCssClass } = props;
    const { imageUrl, innerPadding, outerPadding, columnsWidths } = section;
    if (innerPadding === undefined) {
        return null;
    }
    const direction = isRtl ? 'rtl' : 'ltr';
    const textAlign = isRtl ? 'right' : 'left';
    const imagePadding = isRtl
        ? `${innerPadding.top}px ${innerPadding.right}px ${innerPadding.bottom}px 20px`
        : `${innerPadding.top}px 20px ${innerPadding.bottom}px ${innerPadding.left}px`;
    const textRightPadding = isRtl
        ? imageUrl
            ? '0px'
            : `${innerPadding.left}px`
        : `${innerPadding.right}px`;
    const textLeftPadding = isRtl
        ? `${innerPadding.left}px`
        : imageUrl
            ? '0px'
            : `${innerPadding.right}px`;
    return (React.createElement(WrapperItem, null,
        React.createElement(Section, { backgroundColor: section.backgroundColor, borderBottom: section.borderBottom, borderLeft: section.borderLeft, borderRight: section.borderRight, borderTop: section.borderTop, cssClass: cssClass, padding: shorthand(outerPadding), direction: direction },
            section.imageUrl && (React.createElement(Column, { cssClass: classnames(columnCssClass, 'section-link-image', section.imageCssClass, mobileFullWidthColumnClassName), padding: imagePadding, width: columnsWidths[0] },
                React.createElement(Image, { cssClass: "so-link-image", src: section.imageUrl, href: section.link, altText: section.previewImageAltText, padding: "0" }))),
            React.createElement(Column, { width: imageUrl ? columnsWidths[1] : '100%', cssClass: classnames(columnCssClass, section.textCssClass, imageUrl ? 'section-link-text' : '', mobileFullWidthColumnClassName), paddingTop: `${innerPadding.top}px`, paddingBottom: `${innerPadding.bottom}px`, paddingRight: textRightPadding, paddingLeft: textLeftPadding },
                React.createElement(Text, { padding: "0px", align: textAlign },
                    React.createElement("a", { className: "so-global-h3 so-link-href", href: section.link, target: "_blank", rel: "noopener noreferrer" },
                        React.createElement(LinkWrapper, { fontWeight: "inherit" }, section.title)),
                    React.createElement("p", { className: "so-global-p2" }, section.description))))));
};
//# sourceMappingURL=section-link.js.map